import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconComponent } from '@degreed/apollo';
import { TranslateService } from '@ngx-translate/core';
import { AutomationsFacade } from '../facades/automations.facade';
import { AutomationCloneDialogData } from '../model';

@Component({
  selector: 'dgx-automation-clone-modal',
  templateUrl: './automation-clone-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
})
export class AutomationCloneModalComponent {
  private readonly facade = inject(AutomationsFacade);
  private readonly translate = inject(TranslateService);
  private readonly dialogRef = inject(DialogRef);
  public readonly data = inject<AutomationCloneDialogData>(DIALOG_DATA);

  public isSaving = false;
  public readonly i18n = this.translate.instant([
    'Core_Confirm',
    'Automation_CloneAutomation',
    'Core_Loading',
    'Core_Cancel',
  ]);

  public readonly bodyText = this.translate.instant(
    'Automation_CloneAutomationFormat',
    { name: this.data.automation.ruleName }
  );

  public close() {
    this.dialogRef.close();
  }

  public async onSubmit() {
    this.isSaving = true;
    const clone = await this.facade.cloneAutomation(
      this.data.orgId,
      this.data.automation
    );
    this.dialogRef.close(clone);
  }
}
